module.exports = __webpack_public_path__ + "media/images/article/2021_09-0398e8d67ab7d2701dba543c556f4f98.png";